// i18next-extract-mark-ns-start LandingAds

/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from '../../types/t-types';
import withOrderContext from '../../withOrderContext';
import Layout from '../../layouts/index';
import routes from '../../Routes';
import { Container, Content } from '../../components/home/v2/styledComponents';
import { Button } from '../../components/home/v4/styledComponents';
import ArgumentsBanner from '../../components/home/v4/ArgumentsBanner';
import Feedbacks from '../../components/home/v5/Feedbacks';
import RepairBonusHowItWorks from '../../components/home/RepairBonusHowItWorks';
import RepairBonusLP from '../../components/LandingPage/RepairBonusLP';
import IntroLP from '../../components/LandingPage/IntroLP';
import MenuBar from '../../components/home/MenuBar';
import FootNote from '../../components/LandingPage/FootNote';
import Footer from '../../components/home/v3/Footer';
import FAQBlock from '../../components/FAQBlock';
import CTALink from '../../components/CTALink';
import TipsServices from '../../components/home/OurServices/TipsServices';

import repairClothes from '../../assets/landingPages/repairClothes.jpg';
import repairShoes from '../../assets/landingPages/repairShoes.jpg';
import repairLeatherGoods from '../../assets/landingPages/repairLeatherGoods.jpg';
import repairInterior from '../../assets/landingPages/repairInterior.jpg';

export const repairTypes = (t: TFunction) => [
  {
    image: repairClothes,
    title: t('Réparation de vêtements'),
    // eslint-disable-next-line max-len
    text: t('Réparez les trous, les accrocs et les déchirures de vos vêtements pour leur donner une seconde vie. Finissez-en avec les trous de mite, les jeans troués ou déchirés, les boutons pressions cassés.\n\nNos artisans couturiers réparent vos pantalons, manteaux, robes, costumes, pulls, maillots de bain et lingerie. Grâce à leur expertise, ils vous proposent un service rapide et soigné, adapté à votre besoin.\n\nProfitez des réductions du Bonus Réparation sur toutes les réparations de vos habits.'),
    preFilledSteps: {
      selectedCategory: 'clothes',
    },
  },
  {
    image: repairShoes,
    title: t('Réparation de cordonnerie'),
    // eslint-disable-next-line max-len
    text: t('Nos cordonniers proposent des solutions complètes pour réparer, entretenir et rénover tous types de chaussures : souliers, baskets, chaussures plates ou à talons, bottes, bottines ou sneakers.\n\nNos artisans cordonniers prennent soin de vos paires de chaussures en tissu et en cuir en les nettoyant, en changeant leur semelle ou leur talon, en posant des patin ou en réparant les accrocs et déchirures.\n\nProfitez des réductions du Bonus Réparation sur toutes les réparations de vos chaussures.'),
    preFilledSteps: {
      selectedCategory: 'shoes',
    },
  },
  {
    image: repairLeatherGoods,
    title: t('Réparation de maroquinerie'),
    // eslint-disable-next-line max-len
    text: t('Prenez soin et réparez vos sacs et accessoires en cuir pour les faire perdurer dans le temps.\n\nNos experts en maroquinerie proposent un ensemble de soin et de réparation sur-mesure pour vos sacs, ceintures et portefeuilles : Réparation de zip cassé, cuir abîmé, anse déchirée, nettoyage et soin complet ou recoloration.'),
    preFilledSteps: {
      selectedCategory: 'accessories',
    },
  },
  {
    image: repairInterior,
    title: t('Réparation de linge de maison'),
    text: t('Prenez soin de votre décoration d‘intérieur en réparant et en ravivant votre linge de maison. Nos services s‘étendent des rideaux au linge de lit, du linge de table aux canapés et chaises.\n\n Nos experts couturiers vous proposent de réparer les accrocs, les trous, les déchirures et les zips cassés, de camoufler les taches avec une broderie ou de transformer vos articles en de nouveaux objets.'),
    preFilledSteps: {
      selectedCategory: 'deco',
    },
  },
];

export const FAQRepair = (t: TFunction) => [
  {
    question: t('Quel est l’objectif du Bonus Réparation ?'),
    answers: [t('Le fonds de réparation créé par la loi AGEC a un objectif clair : allonger la durée de vie de nos biens de consommation TLC afin de réduire le volume de déchets.\n\nGrâce au Bonus Réparation, les consommateurs peuvent bénéficier de remises allant de 6 à 25€ sur certaines réparations textiles et de cordonnerie. Cette incitation financière vise à encourager davantage de personnes à choisir la réparation plutôt que le remplacement de leurs vêtements et chaussures.')],
  },
  {
    question: t('Comment fonctionne le Bonus Réparation ?'),
    answers: [t('À partir d‘octobre 2023, tous les retoucheurs et cordonniers labellisés participeront au dispositif du Bonus Réparation. Concrètement, si vous êtes un consommateur et que vous souhaitez faire réparer un vêtement comme un jeans avec une déchirure simple, par exemple, le prix actuel chez Tilli est de 12€. Grâce au Bonus Réparation, le prix de cette réparation passera à seulement 5€. Cependant, certaines catégories, telles que le cuir, les sous-vêtements et les rideaux, ne sont pas encore éligibles au Bonus pour le moment.')],
  },
  {
    question: t('Quel est le rôle de Tilli ?'),
    answers: [t('Tilli est un service unique qui vous permet de prendre soin et de réparer les objets du quotidien : vêtements, textiles de maison, sac ou chaussures. Trois options s’offrent à vous pour cela : prenez rendez-vous avec l’un de nos artisans à domicile, ou envoyez nous vos pièces en envoi de colis, ou visitez nos ateliers situés à Paris.')],
  },
];

type LandingMainRepairClothesType = {
  slug: string;
  path: string;
  preFilledSteps: {
    selectedCategory: string;
  };
  footNote: {
    title: string;
    paragraph: string;
    breadcrumbIntro: {
      paragraph: string;
      links: string[];
    };
  };
  breadcrumb: {
    name: string;
    item: string;
  }[];
};
const LandingMainRepairClothesProps: LandingMainRepairClothesType = {
  slug: 'MainRepairClothesPage',
  path: '/reparation-vetement/',
  preFilledSteps: {
    selectedCategory: 'clothes',
  },
  footNote: {
    title: 'En savoir plus',
    // eslint-disable-next-line max-len
    paragraph: 'Réparer ses vêtements et accessoires était autrefois une pratique courante. Aujourd’hui, avec nos vies bien remplies, on n‘a plus toujours le temps de s‘en occuper. C‘est là que notre service de réparation entre en jeu. ;)\n\n Tilli vous propose un service de réparation à domicile pour vos vêtements, chaussures et accessoires. Nos artisans qualifiés peuvent réparer une grande variété d’articles, qu‘il s‘agisse d‘une fermeture éclair cassée, d’un talon usé, ou encore d’une pièce en cuir abîmée. Que vous ayez besoin de réparations simples ou plus complexes, nos experts redonneront vie à vos articles préférés. Lors de votre rendez-vous, notre artisan évaluera les réparations nécessaires et vous expliquera en détail les coûts et les étapes. Vous pouvez aussi envoyer vos accessoires par colis si vous le préférez. Prolongez la durée de vie de vos produits sans effort, tout en restant chez vous !',
    breadcrumbIntro: {
      // eslint-disable-next-line max-len
      paragraph: 'Votre service de <link>réparations de vêtements disponible à Paris<link>, <link>Lyon<link>, <link>Bordeaux<link>, <link>Marseille<link>, <link>Toulouse<link>, <link>Nantes<link>, <link>Rennes<link>, <link>Lille<link>, <link>Nice<link>, <link>Montpellier<link> et dans une quinzaine d’autres villes en France ou à <link>Bruxelles<link>.',
      links: ['/reparation-vetement/paris/', '/reparation-vetement/lyon/', '/reparation-vetement/bordeaux/', '/reparation-vetement/marseille/',
        '/reparation-vetement/toulouse/', '/reparation-vetement/nantes/', '/reparation-vetement/rennes/', '/reparation-vetement/lille/', '/reparation-vetement/nice/',
        '/reparation-vetement/montpellier/', '/reparation-vetement/bruxelles/'],
    },
  },
  breadcrumb: [
    { name: 'Accueil', item: '/' },
    { name: 'Réparation Vêtement', item: '/reparation-vetement/' },
  ],
};

function LandingMainRepairClothes() {
  const {
    slug, footNote, breadcrumb,
  } = LandingMainRepairClothesProps;
  const { t } = useTranslation();

  return (
    <Layout routeSlug={slug}>
      <Container>
        <Content full hasNoBanner>
          <MenuBar />
          <IntroLP />
          <RepairBonusLP />
          <TipsServices articles={repairTypes(t)} />
          <RepairBonusHowItWorks />
          <ArgumentsBanner
            landingPages
            landingPagePath="repair"
            button={(
              <CTALink to={routes.Step1.url} fromInteraction="repair-bonus_arguments">
                <Button dark>{t('Faire mon devis')}</Button>
              </CTALink>
            )}
          />
          <Feedbacks
            button={(
              <CTALink to={routes.Step1.url} fromInteraction="LandingMainRepairClothes_feedback">
                <Button dark>{t('Réparer')}</Button>
              </CTALink>
            )}
          />
          <FAQBlock questions={FAQRepair(t)} />
          <FootNote
            title={footNote.title}
            paragraph={footNote.paragraph}
            breadcrumbIntro={footNote.breadcrumbIntro.paragraph}
            breadcrumbIntroLinks={footNote.breadcrumbIntro.links}
            itemListElement={breadcrumb}
            isLeatherGoods
          />
        </Content>
        <Footer />
      </Container>
    </Layout>
  );
}

export default withOrderContext(LandingMainRepairClothes);
